/**
 * TV vendor (manufacturer)
 */
export enum TvVendor {
  Loewe = 'loewe',
  Amino = 'amino',
  LG = 'lg',
  TizenTep = 'tizen_tep',
  Tizen = 'tizen',
  Samsung = 'samsung',
  PhilipsOld = 'philips_old',
  Philips = 'philips',
  Tvip = 'tvip',
  Mag = 'mag',
  Sony = 'sony',
  Vestel = 'vestel',
  AndroidTv = 'androidtv',
  Desktop = 'desktop',
}
